<template>
  <div>
    <p class="visually-hidden">
      {{ days }} {{ days > 1 ? "Tage" : "Tag" }}, {{ hours }} Stunden, {{ minutes }} Minuten, {{ seconds }} Sekunden
    </p>
    <ul class="countdown" aria-hidden="true">
      <li v-if="days > 0">
      <div class="digit">{{ days | twoDigits }}</div>
      <div class="text" v-if="!preview">{{ days > 1 ? "Tage" : "Tag" }}</div>
      <div class="text" v-else>{{ days > 1 ? "Tagen" : "Tag" }}</div>
    </li>
    <li>
      <div class="digit">{{ hours | twoDigits }}</div>
      <div class="text">Stunden</div>
    </li>
    <li>
      <div class="digit">{{ minutes | twoDigits }}</div>
      <div class="text">Minuten</div>
    </li>
    <li>
      <div class="digit">{{ seconds | twoDigits }}</div>
      <div class="text">Sekunden</div>
    </li>
  </ul>
</div>
</template>

<script>
let interval = null;
import moment from "moment";

export default {
  name: "vuejsCountDown",
  props: {
    preview: {
      type: Boolean,
      required: false,
      default: false
    },
    countdownDate: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      now: null,
      diff: 0
    };
  },
  created() {
    this.now = new moment();
    interval = setInterval(() => {
      this.now = new moment();
    }, 1000);
  },
  computed: {
    date() {
      return new moment(this.countdownDate);
    },

    seconds() {
      return Math.trunc(this.diff) % 60;
    },

    minutes() {
      return Math.trunc(this.diff / 60) % 60;
    },

    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24;
    },

    days() {
      return Math.trunc(this.diff / 60 / 60 / 24);
    }
  },
  watch: {
    now(value) {
      this.diff = this.date.diff(this.now) / 1000;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
        // Remove interval
        clearInterval(interval);
      }
    }
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return "0" + value.toString();
      }
      return value.toString();
    }
  }
  /*
  destroyed() {
    clearInterval(interval);
  }
  */
};
</script>
<style lang="scss">
@import "../scss/settings";
.countdown {
  padding: 0;
  margin: 26px 0;
  li {
    display: inline-block;
    margin: 0 16px;
    text-align: center;
    position: relative;
    @include mobile {
      margin: 0 10px;
    }
    &:after {
      content: ":";
      position: absolute;
      top: 10px;
      right: -20px;
      @include fontDefault;
      font-size: px-to-rem(22);
      line-height: 1;
      color: rgba(255, 255, 255, 0.4);
      @include mobile {
        top: 5px;
        right: -10px;
      }
    }
    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
    &:last-of-type:after {
      content: "";
    }
  }
  .digit {
    min-width: 55px;
    display: block;
    @include fontDefault;
    font-size: px-to-rem(42);
    line-height: 1;
    color: #ffffff;
    margin-bottom: 4px;
    text-align: center;
    padding-right: 4px;
    @include mobile {
      font-size: px-to-rem(34);
      min-width: 50px;
      padding-right: 2px;
    }
  }
  .text {
    @include fontDefault;
    font-size: px-to-rem(14);
    letter-spacing: px-to-rem(-0.5);
    color: rgba(255, 255, 255, 1);
    text-align: center;
    padding: 0;
    @include mobile {
      font-size: px-to-rem(12);
    }
  }
}
</style>
